<template>
  <transition name="success">
    <span
      v-if="showSuccess"
      class="success-message">
      De link is gekopieerd naar het klembord
    </span>
  </transition>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'SuccessMessage',
  data () {
    return {
      showSuccess: false
    }
  },
  mounted () {
    EventBus.$on('success', el => {
      this.showSuccess = true
    })
  },
  watch: {
    showSuccess () {
      if (this.showSuccess) {
        setTimeout(() => {
          this.showSuccess = false
        }, 3000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.success-message {
  position: fixed;
  font-size: 16px;
  color: white;
  background-color: $c-pink;
  display: inline-block;
  padding: 7px 13px 8px;
  line-height: 1;
  z-index: 200;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
  cursor: default;
  opacity: 1;
}

.success-enter-active,
.success-leave-active {
  transition: all .3s cubic-bezier(.19,1,.22,1);
  transition-property: opacity, transform;
  will-change: opacity, transform;
}

.success-enter,
.success-leave-to {
  opacity: 0;
  transform: translateY(25px) translateX(-50%);
}
</style>
